module.exports = __webpack_public_path__ + "static/handoffArtwork@2x-caebf3eadacddcea61e59ce2de37f577.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/handoffArtwork@2x.jpg
// module id = 2604
// module chunks = 168707334958949